export default __webpack_public_path__ + "static/media/upload-icon.84ef2666.svg";